class FaqsSplit extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('[data-faq-toggle]');
    this.showMoreLabel = this.dataset.showMoreLabel || 'Show more';
    this.showLessLabel = this.dataset.showLessLabel || 'Show less';
  }

  connectedCallback() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => this.toggle());
    }
    this._initAccordions();
  }

  toggle() {
    const isExpanded = this.classList.toggle('is-expanded');
    this.toggleButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    this.toggleButton.textContent = isExpanded ? this.showLessLabel : this.showMoreLabel;
  }

  _initAccordions() {
    const items = this.querySelectorAll('.faqs-split__item');

    items.forEach((details) => {
      const summary = details.querySelector('.faqs-split__summary');
      const answer = details.querySelector('.faqs-split__answer');
      if (!summary || !answer) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = details.hasAttribute('open');

        if (isOpen) {
          // Đóng: animate về 0
          answer.style.maxHeight = answer.scrollHeight + 'px';
          answer.offsetHeight; // force reflow
          answer.style.maxHeight = '0';
          answer.style.opacity = '0';

          const onClose = () => {
            details.removeAttribute('open');
            answer.removeEventListener('transitionend', onClose);
          };
          answer.addEventListener('transitionend', onClose);
        } else {
          // Mở: set [open] trước rồi animate
          details.setAttribute('open', '');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          answer.style.opacity = '1';

          const onOpen = (ev) => {
            if (ev.propertyName !== 'max-height') return;
            answer.style.maxHeight = 'none';
            answer.removeEventListener('transitionend', onOpen);
          };
          answer.addEventListener('transitionend', onOpen);
        }
      });
    });
  }
}

customElements.define('faqs-split', FaqsSplit);
